import React, { useEffect, useState } from 'react';
import './assets/style/App.css';
import './assets/style/Colors.css';
import Layout from './pages/layout/Layout';
import { Bounce, ToastContainer } from 'react-toastify';
import {
  checkAuthenticated,
  getLoggedUserDetails,
  loginSelector,
} from './features/loginSlice';
import {
  updateDeviceStatus,
  updateSideMenuStatus,
} from './features/dashboardSlice';
import { SIDE_MENU_STATUS } from './utils/Constant';
import { useAppDispatch, useAppSelector } from './store/redux-hooks';
import { MapOptionType, LoggedUserType, UserType } from './utils/Types';
import {
  getZonesAndStates,
  locationFilterSelector,
} from './features/locationFilterSlice';
import {
  prepareDataToFindCity,
  prepareDataToFindZoneAndState,
} from './utils/Util';
import { getAllRoles, getRollDrops } from './features/trackLocationSlice';

function App() {
  const dispatch = useAppDispatch();
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const statesData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const [width, setWidth] = useState<number>(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    const isMobile = width <= 768;
    if (width <= 1000) {
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.CLOSE));
    } else {
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.OPEN));
    }
    dispatch(updateDeviceStatus({ isMobile }));
  }, [width]);
  useEffect(() => {
    dispatch(checkAuthenticated());
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  useEffect(() => {
    if (user?.candidateId) {
      dispatch(getLoggedUserDetails(user.candidateId));
      dispatch(getRollDrops());
      dispatch(getAllRoles());
    }
  }, [user]);

  useEffect(() => {
    const data = prepareDataToFindZoneAndState(user, userDetails);
    if (data) {
      const modifiedData = {
        zoneId: data.zoneId.length > 0 ? data.zoneId.join(',') : '',
        stateId: data.stateId.length > 0 ? data.stateId.join(',') : '',
      };

      dispatch(getZonesAndStates(modifiedData));
    }
  }, [userDetails]);

  useEffect(() => {
    const data = prepareDataToFindCity(
      user,
      userDetails,
      statesData,
      districtData
    );
    if (data) {
      const modifiedData = {
        zoneId: data.zoneId.length > 0 ? data.zoneId.join(',') : '',
        stateId: data.stateId.length > 0 ? data.stateId.join(',') : '',
      };
      dispatch(getZonesAndStates(modifiedData));
    }
  }, [statesData]);
  return (
    <div className="App">
      <Layout />
      <ToastContainer
        className="toast-style"
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
}

export default App;
